import { apiClient } from './client';
import type { NotificationPreferences } from '@/types';

export const notificationsApi = {
    async getPreferences(): Promise<NotificationPreferences> {
        const raw = await apiClient.get<Record<string, unknown>>('account/notification-preferences');
        return { emailEnabled: raw.email_enabled as boolean };
    },

    updatePreferences(data: NotificationPreferences) {
        return apiClient.put<NotificationPreferences>('account/notification-preferences', {
            email_enabled: data.emailEnabled,
        });
    },
};
